import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import StickyBox from 'react-sticky-box';
// import InfiniteScroll from 'react-infinite-scroller';
import parse from 'html-react-parser';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import SEO from 'next-seo.config';
import Head from 'next/head';
import { useRouter } from 'next/router';
import WidgetBreadcrumb from 'src/2.0/widgets/widget-breadcrumb';
import WidgetHeading from 'src/2.0/widgets/widget-heading';
import Layout from 'src/components/layouts';
import { APP_IMG, APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { isRender, useDesktop } from 'src/utils/device';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';

const PageError = dynamic(import('pages/404'));
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'));
const CardH = dynamic(import('src/components/cards/card-h'));
const CardV = dynamic(import('src/components/cards/card-v'));
const SectionFullH = dynamic(import('src/components/sections/section-full-h'));
const SectionAffiliate = dynamic(import('src/components/sections/section-event/section-affiliate'));
const SectionNationWeekEnd = dynamic(import('src/components/sections/section-event/section-nation-weekend'));

const PageCategory = ({ articles, nextArticles, category, subCategory, lastNews, meta, ads, dataAffiliate, dataAdsHeader, nationWeekEnd }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (articles === null) {
    return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  }
  const router = useRouter();
  /* -------------------------------- START : LOADMORE -------------------------------- */
  const nextLinkRef = useRef(nextArticles);
  const listArticlesRef = useRef(articles);
  const [listArticles, setListArticles] = useState(articles);
  const [show, setShow] = useState(12);
  const [adsBox, setAdsBox] = useState(true);
  const [isLoad, setIsLoad] = useState(true);
  const [loadData, setLoadData] = useState(false);
  const handleLightBoxClick = () => {
    setAdsBox(false);
  };
  const handleLoad = async () => {
    setLoadData(true);
    try {
      if (nextArticles && isLoad) {
        const resData = await GET_ARTICLES(`${nextLinkRef.current || ''}`, false, true);
        // console.log(`${nextLinkRef.current}${convertObjPath({ limit: 20 })}`)
        if (!_.isEmpty(resData?.data)) {
          nextLinkRef.current = resData?.nextTo || resData?.links?.next;
          const newLists = [...listArticlesRef.current, ...resData?.data];
          listArticlesRef.current = _.uniqBy(newLists, 'id');
          setListArticles(listArticlesRef.current);
        }
      }
      setShow(show + 12);
      setIsLoad(!isLoad);
    } catch (err) {
      console.error(`${timestamp()} ==========> LOAD_CATEGORY_LIST ERROR : ${nextLinkRef?.current}`, err);
    }
    setLoadData(false);
  };
  const cloneListArticles = [...listArticles];
  // console.log({ cloneListArticles, articles });
  const onTopArticle = cloneListArticles.splice(0, 5);

  let baseUrlCategory = `${APP_URL}/category/${category?.en}`;
  const _article = {
    title: meta?.title || WEB_TITLE,
    description: meta?.description || WEB_DESC,
    keyword: meta?.keyword || WEB_KEYWORD
  };

  let setItemListElement = '';

  if (subCategory?.en) {
    baseUrlCategory = `${APP_URL}/category/${category?.en}/${subCategory?.en}`;
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "${category?.th}",
        "item": "${APP_URL}/category/${category?.en}"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "${subCategory?.th}",
        "item": "${baseUrlCategory}"
      }
    ]`;
  } else {
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "${category?.th}",
          "item": "${APP_URL}/category/${category?.en}"
        }
      ]`;
  }

  // const { sub } = router.query;
  // const adsPremiumList = ['business'];
  // const adsFinanceList = ['business_finance'];
  // const adsEducationList = ['social_education'];
  // const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });

  // console.log(nextLinkRef);
  // const titleEscape = escapeChar(meta.title);
  const categoryNameTH = subCategory?.th ? subCategory?.th : category?.th;

  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        {...SEO}
        title={_article?.title}
        description={_article?.description}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
        openGraph={{
          ...SEO.openGraph,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title} />
        <meta property='twitter:description' content={_article?.description} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />

        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                 __th_page="${subCategory?.en ? subCategory.en : category?.en}";
            `
          }}
        />
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* ---------------------------- SPIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "${WEB_NAME}",
                "url": "${WEB_URL.WEB}",
                "description": "${_article?.description}",
                "sameAs": [
                  "${WEB_URL.FACEBOOK}",
                  "${WEB_URL.TWITTER}",
                  "${WEB_URL.INSTAGRAM}",
                  "${WEB_URL.YOUTUBE}",
                  "${WEB_URL.LINE}"
                ],
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "${WEB_URL.WEB}search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            `
          }}
        />

        {/* ---------------------------- SPIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "http://schema.org",
                  "@type": "WebPage",
                  "name": "${categoryNameTH}",
                  "description": "${_article?.description}",
                  "publisher": {
                    "@type": "ProfilePage",
                    "name": "${WEB_NAME}"
                  }
                }
              `
          }}
        />

        {/* ------------------------ SPIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": ${setItemListElement}
              }
            `
          }}
        />
      </Head>

      {!_.isEmpty(dataAffiliate) && <SectionAffiliate position={4} data={dataAffiliate} />}
      <Layout sessionSevId={sessionSevId}>
        {/* ---------------------------- ADS : LIGHTBOX ----------------------------- */}
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.LIGHTBOX} data={ads} handler={() => handleLightBoxClick()} adsBox={adsBox} />}
        {/* </div>
        </div>} */}
        {/* ---------------------------- ADS : BILLBOARD ----------------------------- */}
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
        <Section1 id='section-1' className='category-wrapper'>
          <div className='container'>
            <WidgetBreadcrumb
              article={{
                section: category,
                subCategory: subCategory
              }}
            />
            {/* <ul className='breadcrumb'>
              <li>
                <a href='/'>หน้าแรก</a>
              </li>
              <li>{categoryNameTH}</li>
            </ul> */}

            <div className='row'>
              <div className='col-lg-8 col-md-12' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
                <h1 className='heading-title'>{categoryNameTH}</h1>
                <div className='row'>
                  {listArticles.length < 1 ? (
                    <div className='col-12 no-article'>
                      <img src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                    </div>
                  ) : (
                    <>
                      <div className='col-12'>
                        <SectionFullH
                          data={onTopArticle}
                          heading={false}
                          include={false}
                          txtSize={isRender('desktop') ? '--large' : '--small'}
                          ads={ads}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'ข่าวทั้งหมด',
                            position: 'ใต้:โฆษณาตำแหน่ง billboard',
                            data: {
                              block: '1',
                              heading: categoryNameTH
                            }
                          }}
                        />
                      </div>
                      {/* </InfiniteScroll> */}
                    </>
                  )}
                </div>
              </div>

              <div className='col-lg-4 col-md-12 d-lg-block d-none'>
                <StickyBox offsetTop={70} offsetBottom={70}>
                  {/* ---------------------------- ADS : STICKY-1 ----------------------------- */}

                  {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />}

                  <div className='widget-content' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
                    <WidgetHeading heading='Latest News' />
                    <div className='block-content'>
                      {Array.isArray(lastNews) && lastNews.length < 1 ? (
                        <div className='no-article'>
                          <img className='--side' src={`${APP_IMG}/no-article.png`} alt='no-article' width='100%' />
                        </div>
                      ) : (
                        <ul className='block-list'>
                          {lastNews.slice(0, 4).map((item, index) => (
                            <li key={index}>
                              <CardH
                                data={item}
                                large={false}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'Latest News',
                                  position: 'ใต้:โฆษณาตำแหน่ง Sticky Box',
                                  data: {
                                    block: '2',
                                    title: item.title,
                                    heading: 'Latest News',
                                    index: index + 1
                                  }
                                }}
                              />
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  {/* ---------------------------- ADS : STICKY-2 ----------------------------- */}
                  {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />}
                </StickyBox>
              </div>
            </div>
          </div>
        </Section1>

        {/* ================================ nation-weekend  ================================ */}
        <SectionNationWeekEnd ads={ads} data={nationWeekEnd} />

        <Section2 className='section-2 container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          <div className='row'>
            {cloneListArticles.slice(0, show).map((item, index) => (
              <div key={item.id} id={index + 1} className='col-12 col-md-4 mb-4'>
                <CardV
                  data={item}
                  description={false}
                  badge={true}
                  path={item.link}
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_POSITION,
                    router: router?.pathname,
                    section: 'ข่าวทั้งหมด',
                    position: 'ใต้:โฆษณาตำแหน่ง billboard',
                    data: {
                      block: '1',
                      title: item.title,
                      heading: categoryNameTH,
                      index: index + 6
                    }
                  }}
                />
              </div>
            ))}
            <ButtonContainer>{loadData ? <text> Loading ... </text> : <button onClick={handleLoad}> ดูเพิ่มเติม</button>}</ButtonContainer>
          </div>
        </Section2>
        {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    nextArticles: null,
    category: null,
    subCategory: null,
    lastNews: null,
    meta: null,
    ads: [],
    dataAffiliate: [],
    dataAdsHeader: null,
    nationWeekEnd: []
  };
  const scriptBrowser = await GET('/api/headerAds');
  if (!_.isEmpty(scriptBrowser)) {
    initProps.dataAdsHeader = scriptBrowser || '';
  }
  const uri = 'categories/politics';

  try {
    const regex = /([ก-๙])/;
    if (regex.test(query?.cid)) {
      res.setHeader('location', '/category/latest-news');
      res.statusCode = 301;
      res.end();
    }
    const resData = await GET_ARTICLES(`/api/v1.0/${uri}`, false, true);
    let resDataTo = null;

    if (resData?.statusCode === 404 || _.isUndefined(resData)) {
      return {
        notFound: true
      };
    }
    if (!_.isEmpty(resData)) {
      if (_.isEmpty(resData?.data)) {
        resDataTo = await GET_ARTICLES(`${resData?.nextTo}`, false, true);
        // console.log('#1', resDataTo);
        initProps.articles = resDataTo?.data || [];
      } else {
        initProps.articles = resData?.data || [];
      }
      initProps.nextArticles = resData?.nextTo || resData?.links?.next || null;
      initProps.category = resData?.category;
      initProps.subCategory = resData?.subCategory;
      initProps.lastNews = resData?.last_news || [];
      initProps.meta = resData.meta;
      initProps.ads = resData?.ads || [];
      initProps.dataAffiliate = resData?.affiliate || [];
    }

    const dataSetsAll = await GET(`/api/datasets${convertObjPath({})}`);
    if (!_.isEmpty(dataSetsAll)) {
      initProps.nationWeekEnd = _.find(dataSetsAll, { topic: 'section-nation-weekend' }) || [];
    }
  } catch (err) {
    console.log('==========> CATEGORY ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }
  return {
    props: initProps
  };
}

export default PageCategory;

const ButtonContainer = styled.div`
  text-align: center;
  padding-bottom: 20px;
  button {
    width: 100%;
    border: 1px solid #e3e3e3;
    background-color: #e3e3e3;
    color: #555555;
    border-radius: 5px;
    font-size: 18px;
    padding: 5px 0;
    :hover {
      border: 1px solid #0600e7;
      background-color: #0600e7;
      color: #fff;
      transition: background-color 0.8ms linear;
    }
  }
`;

const Section1 = styled.div`
  .block-wrapper {
    margin-bottom: 0;
    .card-v-content-title {
      font-size: 24pt !important;
      font-family: 'DBHelvethaicaXBd', sans-serif !important;
    }
    @media (max-width: 690px) {
      .card-v-content-title {
        font-size: 20pt !important;
      }
      .card-h-content-title {
        font-size: 16pt !important;
      }
    }
  }
  .heading-title {
    font-size: 30pt;
    font-family: 'DBHelvethaicaXBd', sans-serif;
  }
`;

const Section2 = styled.div`
  .row {
    .col-md-4 {
      width: 25%;
      @media (max-width: 1024px) {
        width: 33.33333%;
      }
      @media (max-width: 690px) {
        width: 50%;
      }
    }
    .mb-4 {
      @media (max-width: 690px) {
        margin-bottom: 0 !important;
      }
    }
  }
`;
